import CityPageTemplate from "../city-template/CityPageTemplate";
import { raymondConfig } from "./data";

export default function RaymondPage() {
  return <CityPageTemplate config={raymondConfig} />;
}